export default __webpack_public_path__ + "static/media/phone_icon_mozambique.9ef9c365.png";